import Trans from 'next-translate/Trans'
import GHref from 'tennders-market/common/components/element/GHref'
import useSession from 'tennders-auth/hooks/useSession'

const TrackMsg = ({ transaction }) => {
  const { isBroker } = useSession()
  return (isBroker() || transaction?.isMarketPlaced)
    ? (
      <div className="text-12 text-right lh-1-3 mb-10">
        <Trans i18nKey="offer:trackMsgForBroker" />
      </div>
    ) : (
      <div className="text-12 text-right lh-1-3 mb-10">
        <Trans i18nKey="offer:trackMsg" />
      </div>
    )
}

const TrackButton = ({ transaction, tracked, onClick }) => {
  const { isShipperUser, isCarrierUser } = useSession()

  if (isShipperUser || isCarrierUser) {
    return null
  }

  return (
    tracked
      ? <TrackMsg transaction={transaction} />
      : (
        <>
          <div className="text-12 text-right lh-1-3 mb-10">
            <Trans i18nKey="offer:lastOfferMsg" />
          </div>
          <GHref
            onClick={onClick}
            className="btn-border standard-btn small mr-10  tennders-counter-btn"
          >
            <Trans i18nKey="offer:track" />
          </GHref>
        </>
      )
  )
}

export default TrackButton
